import AWS from "aws-sdk";
import { Auth } from "aws-amplify";
import { GITHUB_AUTH_FLOW, ROUTES } from "../constants";
import { deleteUser } from "../pages/Users";
import { addSpinner, removeSpinner } from "../components/organisms/Spinner";

const { LOGIN } = ROUTES;
const { GITHUB } = GITHUB_AUTH_FLOW;
const {
  REACT_APP_AWS_REGION,
  REACT_APP_AWS_ACCESS_KEY_ID,
  REACT_APP_AWS_SECRET_ACCESS_KEY,
  REACT_APP_USER_POOL_ID,
} = process.env;

const cognito = new AWS.CognitoIdentityServiceProvider({
  region: REACT_APP_AWS_REGION,
  accessKeyId: REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: REACT_APP_AWS_SECRET_ACCESS_KEY,
});

const handleSignOut = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.assign(LOGIN);
};

export const deleteUserAccount = (user, dispatch, spinnerName) => {
  const cognitoParams = {
    UserPoolId: REACT_APP_USER_POOL_ID,
    Username: user.email,
  };
  spinnerName && dispatch(addSpinner(spinnerName));
  dispatch(deleteUser(user.id))
    .then(async (res) => {
      if (res.payload) {
        user.provider === GITHUB
          ? handleSignOut()
          : await cognito
              .adminDeleteUser(cognitoParams)
              .promise()
              .then(() => {
                const promise = Promise.resolve(Auth.signOut());
                promise
                  .then(() => {
                    spinnerName && removeSpinner(spinnerName);
                    handleSignOut();
                  })
                  .catch((err) => console.log(err));
              });
      }
    })
    .catch(() => spinnerName && removeSpinner(spinnerName));
};
